<template>
  <div class="homeheader-style">
    <div class="homebanner-style" @click="golargescreen" v-if="isbannerhome">
      <img
        class="homebanner-png"
        src="@/assets/image/largescreen/bannertitle.png"
        alt=""
      />
      <img
        @click.stop="onCloseClick"
        class="closehome-img"
        src="@/assets/image/largescreen/closehome.svg"
        alt=""
      />
    </div>
    <div class="homeheader-main">
      <div class="leftheader">
        <div class="homeheader-logo">
          <img
            v-if="logoimgurl"
            :src="logoimgurl"
            alt="logo"
            @error="handleLogoLoadError"
          />
        </div>
        <div class="header-content">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="transparent"
            text-color="#fff"
            active-text-color="#05ABFA"
            router
          >
            <el-menu-item index="/home" class="hometext">
              <span class="homeAiStyle">
                <span>{{ $t("pages.home.initilarolemenu.home") }}</span>
              </span>
            </el-menu-item>
            <!-- <el-menu-item index="/datacase/researchanalysis" class="hometext"
              >大盘数据</el-menu-item
            > -->

            <el-submenu index="4">
              <template slot="title">{{
                $t("pages.home.initilarolemenu.helpCenter")
              }}</template>
              <el-menu-item index="/help/Product-function"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                  <path
                    d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
                  /></svg
                ><span>{{
                  $t("pages.home.initilarolemenu.productFunction")
                }}</span></el-menu-item
              >
              <el-menu-item index="/help/National-involvment"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" /></svg
                ><span>{{
                  $t("pages.home.initilarolemenu.nationalInvolvement")
                }}</span></el-menu-item
              >
              <el-menu-item index="/help/prosecuteBook"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" /></svg
                ><span>{{
                  $t("pages.home.initilarolemenu.prosecuteBook")
                }}</span></el-menu-item
              >
              <el-menu-item
                index="/help/judgmentBook/policyRegulation"
                v-if="expertServiceMenulist.showPolicyRegulation"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2v20" />
                  <path d="M4 11l-2-2 10-4 10 4-2 2" />
                  <path d="M4 11v5a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2v-5" />
                  <path d="M16 11v5a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2v-5" />
                  <path d="M8 22h8" /></svg
                ><span>{{
                  $t("pages.home.initilarolemenu.policyRegulation")
                }}</span></el-menu-item
              >
              <el-menu-item
                index="/help/judgmentBook/blockchainKnowledge"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <path d="M23 9v8M1 9l11-5.5L23 9l-11 5.5L1 9z" />
                  <path
                    d="M4.5 10.75v5.5c0 2.5 3.5 4.5 7.5 4.5s7.5-2 7.5-4.5v-5.5"
                  /></svg
                ><span>链上安全研判知识库</span></el-menu-item
              >
              <el-menu-item
                index="/help/judgmentBook/blockchainCaseInvestigation"
                v-if="expertServiceMenulist.showBlockchainCaseInvestigation"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <polyline points="18 9 18 19 6 19 6 9" />
                  <rect x="4" y="5" width="16" height="4" />
                  <line x1="10" y1="13" x2="14" y2="13" /></svg
                ><span>{{
                  $t("pages.home.initilarolemenu.blockchainCaseInvestigation")
                }}</span></el-menu-item
              >
            </el-submenu>
            <!-- <el-submenu index="8">
              <template slot="title">API</template>
              <el-menu-item index="/api/subscription"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="#3B82F6"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
                  <path d="M12 18V6" /></svg
                ><span>API服务价格</span></el-menu-item
              >

              <el-menu-item index="/api/apiServiceIntroduction"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="#3B82F6"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  />
                  <polyline points="14 2 14 8 20 8" />
                  <path d="m10 13-2 2 2 2" />
                  <path d="m14 17 2-2-2-2" /></svg
                ><span>API服务介绍</span></el-menu-item
              >
            </el-submenu> -->
          </el-menu>
        </div>
      </div>
      <div class="homeheader-right">
        <div @click="golargescreen" class="homeheader-screen">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <rect x="3" y="3" width="18" height="18" rx="2"></rect>
            <path d="M3 9h18"></path>
            <path d="M9 21V9"></path>
          </svg>
          <span>{{ $t("pages.home.initilarolemenu.dataScreen") }}</span>
        </div>
        <MessageBell />
        <el-dropdown class="uesrinfo">
          <span class="el-dropdown-link">
            <img src="@/assets/image/homepage/Ellipse.png" alt="头像" />
            <div class="usertitle">
              <div class="topusername">
                <span>{{ accountsname }}</span>
                <i class="el-icon-caret-bottom"></i>
              </div>
              <span class="btuserroles">{{ userroles }}</span>
            </div>
          </span>
          <el-dropdown-menu slot="dropdown" class="personage-mask">
            <router-link to="/personalinfo">
              <el-dropdown-item>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <span>{{
                  $t("pages.home.initilarolemenu.userCenter")
                }}</span></el-dropdown-item
              >
            </router-link>
            <router-link to="/permissions/feelback">
              <el-dropdown-item>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                  />
                </svg>
                <span>{{
                  $t("pages.home.initilarolemenu.userFeedback")
                }}</span></el-dropdown-item
              ></router-link
            >
            <div class="divider"></div>
            <a @click="loginOut">
              <el-dropdown-item>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="#EF4444"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                <span style="color: #ef4444">{{
                  $t("pages.home.initilarolemenu.logout")
                }}</span>
              </el-dropdown-item></a
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { getUser } from "@/aips/userManage";
import global from "@/components/Global.vue";
import { expertServiceMenu } from "@/aips/policyRegulation";
import { clearStorageForLogout } from "@/utils/storageHelper.js";
import { getPrimaryRoleDisplayName } from "@/utils/roleUtils";
import dayjs from "dayjs";
import MessageBell from "@/components/newtheme/MessageBell.vue";
import defaultHeaderLogo from "@/assets/image/login/logoBlue.png";
export default {
  name: "InitialRoleMenu",
  components: {
    MessageBell,
  },
  data() {
    return {
      isbannerhome: true,
      logoimgurl: null,
      configuredLogoUrl: null,
      logoRetryCount: 0,
      logoRetryTimer: null,
      activeIndex: this.$route ? this.$route.path : "/home",
      ispersonage: true,
      userDetail: null,
      userroles: null,
      accountsname: null,
      expertServiceMenulist: {
        showBlockchainCaseInvestigation: false,
        showBlockchainKnowledge: false,
        showPolicyRegulation: false,
      },
    };
  },
  watch: {
    "$route.path": {
      handler(toPath) {
        console.log(toPath);
        if (toPath == "/home") {
          this.isbannerhome = true;
        } else {
          this.isbannerhome = false;
        }
        this.activeIndex = toPath;
      },
      immediate: true,
    },
  },
  methods: {
    applyHeaderLogo() {
      const logoUrl = this.getConfigValue("logo");
      this.configuredLogoUrl =
        typeof logoUrl === "string" && logoUrl.trim() ? logoUrl.trim() : null;
      this.logoRetryCount = 0;
      this.logoimgurl = this.configuredLogoUrl || defaultHeaderLogo;
    },
    handleLogoLoadError() {
      if (
        this.logoimgurl === this.configuredLogoUrl &&
        this.configuredLogoUrl &&
        this.logoRetryCount === 0
      ) {
        this.logoRetryCount += 1;
        this.logoimgurl = null;
        this.logoRetryTimer = window.setTimeout(() => {
          if (!this._isDestroyed && !this._isBeingDestroyed) {
            this.logoimgurl = this.configuredLogoUrl;
          }
        }, 1000);
        return;
      }

      this.logoimgurl = defaultHeaderLogo;
    },
    golargescreen() {
      this.$router.push("/largescreen");
    },

    onCloseClick() {
      this.isbannerhome = false;
    },
    getexpertServiceMenu() {
      expertServiceMenu().then((res) => {
        console.log(res);

        this.expertServiceMenulist.showBlockchainCaseInvestigation =
          res.data.showBlockchainCaseInvestigation;
        this.expertServiceMenulist.showBlockchainKnowledge =
          res.data.showBlockchainKnowledge;
        this.expertServiceMenulist.showPolicyRegulation =
          res.data.showPolicyRegulation;
      });
    },
    personagefn() {
      this.ispersonage = !this.ispersonage;
    },
    jumpClose() {
      this.ispersonage = false;
    },
    loginOut() {
      this.ispersonage = false;
      clearStorageForLogout();
      this.$router.push("/login");
    },
    getGlobalInfo() {
      setTimeout(() => {
        console.log(global.getConfigdata);
        global.getConfigdata.forEach((resitem) => {
          if (resitem.action == "LOGIN") {
            this.loginresource = resitem.configs;
          }
        });
        this.loginresource.forEach((item) => {
          if (item.configKey == "logo") {
            this.logoimgurl = item.configValue;
            sessionStorage.logoimgurl = JSON.stringify(this.logoimgurl);
          }
        });
      }, 1500);
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
  async created() {
    await this.waitForSiteConfig();
    if (!this._isDestroyed && !this._isBeingDestroyed) {
      this.applyHeaderLogo();
    }
    getUser().then((res) => {
      console.log(res);
      //更改时间
      res.data.modifiedTime = dayjs
        .unix(res.data.modifiedTime)
        .format("YYYY-MM-DD HH:mm");
      //创建日期
      res.data.createTime = dayjs
        .unix(res.data.createTime)
        .format("YYYY-MM-DD HH:mm");
      if (res.data.phoneNumber == "" || res.data.phoneNumber == null) {
        res.data.phoneNumber = this.$t(
          "pages.home.initilarolemenu.noPhoneNumber",
        );
      }
      this.accountsname = res.data.username;
      // console.log(this.accountsname);
      this.userDetail = res.data;
      localStorage.User = JSON.stringify(res.data);
      localStorage.condition = JSON.stringify(res.data.condition);
    });
    this.getexpertServiceMenu();
  },
  mounted() {
    // document.addEventListener("click", (e) => {
    //   const personage = document.getElementById("personage");
    //   if (personage) {
    //     if (!personage.contains(e.target)) {
    //       this.ispersonage = false;
    //     }
    //   }
    // });
    this.userroles = getPrimaryRoleDisplayName();
    // if (sessionStorage.logoimgurl) {
    //   let logoimg = JSON.parse(sessionStorage.logoimgurl);
    //   this.logoimgurl = logoimg;
    // } else {
    //   this.getGlobalInfo();
    // }
  },
  beforeDestroy() {
    if (this.logoRetryTimer) {
      window.clearTimeout(this.logoRetryTimer);
    }
  },
};
</script>
<style lang="less" scoped>
@import "@/assets/css/newhomepage/newmymenu.less";
.homeAiStyle {
  display: flex;
  align-items: center;
  color: #cbcfd4 !important;
  span {
    margin-left: 4px;
  }
}
::v-deep .el-menu-item.is-active .homeAiStyle {
  color: #3b82f6 !important;
  span {
    font-weight: 700 !important;
  }
}
</style>
